import { RoutePaths } from '@interfaces/routePaths'
import { Base } from '@views/Notes/Base'
import { BaseLayout } from '../BaseLayout'

export const NOTES_PATHS = [
  {
    path: RoutePaths.NOTES,
    element: <BaseLayout />,
    children: [
      {
        index: true,
        element: <Base />,
      },
    ],
  },
]
